<table mat-table [dataSource]="transactionModels" class="table-list">
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let transactionModel">
            {{ transactionModel.id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="transaction_type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let transactionModel">
            {{ transactionModel.transaction_type | titlecase }}
            <span *ngIf="transactionModel.refund" title="Refunded"
                >(R#{{ transactionModel.refund.id }})</span
            >
        </td>
    </ng-container>

    <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef>Reference</th>
        <td mat-cell *matCellDef="let transactionModel">
            {{ transactionModel.reference_type | titlecase }}
        </td>
    </ng-container>

    <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let transactionModel">
            <span
                [ngClass]="{
                    'tx-credit': true,
                    'tx-debit':
                        openIdProfile!.id == transactionModel.sender_open_id,
                    'tx-not-approved': transactionModel.result != 'APPROVED',
                    'tx-pending': transactionModel.result == 'PENDING'
                }"
                >{{
                    transactionModel.amount *
                        (openIdProfile!.id == transactionModel.sender_open_id
                            ? -1
                            : 1) | currency
                }}</span
            >
        </td>
    </ng-container>

    <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let transactionModel">
            {{ transactionModel.result | titlecase }}
        </td>
    </ng-container>

    <ng-container matColumnDef="refund">
        <th mat-header-cell *matHeaderCellDef>Refund</th>
        <td mat-cell *matCellDef="let transactionModel">
            <div *ngIf="transactionModel.transaction_type == 'PAYMENT'">
                <app-view-transaction-refund
                    [transactionModel]="transactionModel"
                    [openIdProfile]="openIdProfile"
                ></app-view-transaction-refund>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="sender_receiver">
        <th mat-header-cell *matHeaderCellDef>Sender / Receiver</th>
        <td mat-cell *matCellDef="let transactionModel">
            <span
                [ngClass]="{
                    'tx-credit': true,
                    'tx-pending': transactionModel.result == 'PENDING'
                }"
                *ngIf="transactionModel.sender_open_id != openIdProfile!.id"
                >{{ transactionModel.users.sender }} (S)</span
            >
            <span
                [ngClass]="{
                    'tx-debit': true,
                    'tx-pending': transactionModel.result == 'PENDING'
                }"
                *ngIf="transactionModel.receiver_open_id != openIdProfile!.id"
                >{{ transactionModel.users.receiver }} (R)</span
            >
        </td>
    </ng-container>

    <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>Comment</th>
        <td mat-cell *matCellDef="let transactionModel">
            <span
                class="cursor-pointer"
                (click)="showComment(transactionModel)"
            >
                {{ transactionModel.comment | slice: 0:12 }}
                <span
                    *ngIf="
                        transactionModel.comment &&
                        transactionModel.comment.length > 12
                    "
                >
                    ...</span
                >
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let transactionModel">
            {{ transactionModel.created_at | date: "short" }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
</table>

<div class="grid-split-2" style="align-items: center">
    <div>
        <button class="btn btn-sm btn-success" (click)="reload()">
            <i class="bi bi-arrow-clockwise"></i>
        </button>
    </div>
    <div>
        <mat-paginator
            [length]="pagingItemCount"
            [pageSize]="pagingPageSize"
            showFirstLastButtons
        >
        </mat-paginator>
    </div>
</div>
